const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 60 * 60;
const SECONDS_IN_DAY = 24 * 60 * 60;

// Negative and fractional inputs are clamped so a stale prop cannot render "-1 sec".
const splitDuration = (totalSeconds: number) => {
  const total = Math.max(Math.floor(totalSeconds), 0);

  return {
    days: Math.floor(total / SECONDS_IN_DAY),
    hours: Math.floor((total % SECONDS_IN_DAY) / SECONDS_IN_HOUR),
    minutes: Math.floor((total % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE),
    seconds: total % SECONDS_IN_MINUTE,
  };
};

export default splitDuration;
